import { AlertTriangle, Zap, Circle, CheckCircle } from 'lucide-react';

const urgencyConfig = {
  CRITICAL: {
    bg: 'bg-red-500/15',
    text: 'text-red-400',
    ring: 'ring-1 ring-red-500/35',
    shadow: 'shadow-[0_0_0_1px_rgba(255,59,92,0.35),0_0_24px_rgba(255,59,92,0.18)]',
    icon: AlertTriangle,
    pulse: 'animate-critical-pulse',
  },
  HIGH: {
    bg: 'bg-orange-500/15',
    text: 'text-orange-400',
    ring: 'ring-1 ring-orange-500/35',
    shadow: '',
    icon: Zap,
    pulse: '',
  },
  MODERATE: {
    bg: 'bg-yellow-500/15',
    text: 'text-yellow-400',
    ring: 'ring-1 ring-yellow-500/35',
    shadow: '',
    icon: Circle,
    pulse: '',
  },
  LOW: {
    bg: 'bg-green-500/15',
    text: 'text-green-400',
    ring: 'ring-1 ring-green-500/35',
    shadow: '',
    icon: CheckCircle,
    pulse: '',
  },
  NONE: {
    bg: 'bg-green-500/15',
    text: 'text-green-400',
    ring: 'ring-1 ring-green-500/35',
    shadow: '',
    icon: CheckCircle,
    pulse: '',
  },
};

export const UrgencyBadge = ({ level, size = 'default', showLabel = true }) => {
  const config = urgencyConfig[level] || urgencyConfig.MODERATE;
  const Icon = config.icon;
  
  const sizeClasses = size === 'lg' 
    ? 'px-4 py-2 text-sm gap-2' 
    : size === 'sm' 
      ? 'px-2 py-0.5 text-[10px] gap-1' 
      : 'px-2.5 py-1 text-xs gap-1.5';
  
  const iconSize = size === 'lg' ? 16 : size === 'sm' ? 10 : 12;
  
  return (
    <span
      data-testid="urgency-badge"
      className={`inline-flex items-center rounded-full font-semibold tracking-wide ${sizeClasses} ${config.bg} ${config.text} ${config.ring} ${config.shadow} ${config.pulse}`}
      aria-label={`Urgency: ${level}`}
    >
      <Icon size={iconSize} />
      {showLabel && <span>{level}</span>}
    </span>
  );
};

export const EmergencyFlagBadge = ({ flag }) => {
  const flagConfig = {
    YES: { bg: 'bg-red-500/20', text: 'text-red-300', border: 'border-red-500/40' },
    NO: { bg: 'bg-green-500/20', text: 'text-green-300', border: 'border-green-500/40' },
    UNCERTAIN: { bg: 'bg-yellow-500/20', text: 'text-yellow-300', border: 'border-yellow-500/40' },
  };
  
  const config = flagConfig[flag] || flagConfig.UNCERTAIN;
  
  return (
    <span
      className={`inline-flex items-center px-3 py-1 rounded-md text-xs font-bold tracking-wider border ${config.bg} ${config.text} ${config.border}`}
    >
      {flag}
    </span>
  );
};
